import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 7v14","key":"svg-0"}],["path",{"d":"M9 18l3 3l3 -3","key":"svg-1"}],["path",{"d":"M14 3v4h-4v-4l4 0","key":"svg-2"}]]

/**
 * IconArrowDownSquare
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctZG93bi1zcXVhcmUiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTEyIDd2MTQiIC8+CiAgPHBhdGggZD0iTTkgMThsMyAzbDMgLTMiIC8+CiAgPHBhdGggZD0iTTE0IDN2NGgtNHYtNGw0IDAiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/arrow-down-square
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowDownSquare = createReactComponent('outline', 'arrow-down-square', 'ArrowDownSquare', __iconNode);

export default IconArrowDownSquare;